
define(
	'TavanoTeam.LoyalityLandingForm.LoyalityLandingForm'
,   [
		'TavanoTeam.LoyalityLandingForm.Router'
	]
,   function (
		Router
	)
{
	'use strict';

	return  {
		Router: Router,
		mountToApp: function mountToApp (Application)
		{
			return new Router({
                application: Application
            });			
		}
	};
});
